import { default as SelectMUI } from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';

const Select = ({handleChange, value, label, items=[]}) => {

    return (
        <FormControl  sx={{ m: 1, minWidth: 120 }}  size="small">
            <InputLabel id="demo-simple-select-standard-label">{label}</InputLabel>
            <SelectMUI
                labelId="demo-simple-select-standard-label"
                id="demo-simple-select-standard"
                value={value}
                onChange={handleChange}
                label={label}
            >
                {items.map((item, index)=>{
                    return(
                        <MenuItem key={`period_${index}`} value={item.value}>{item.label}</MenuItem>
                    )
                })}
            </SelectMUI>
        </FormControl>
    )
}

export default Select 